import Vue from 'vue';

import Home from '@/pages/project/home';
import MsgList from '@/pages/project/msgList';
import TaskList from '@/pages/project/tree';
import SplitProject from '@/pages/project/split';
import AddAssist from '@/pages/project/addAssist';
import Project from '@/pages/project/info';
import ProjectManager from '@/pages/project/manager';
import AddProject from '@/pages/project/add';
import Assign from '@/pages/team/assign';
import AssignTeam from '@/pages/team/assignTeam';
import AssignWorker from '@/pages/team/assignWorker';
import TeamList from '@/pages/team/teamList';
import ReleaseAssist from '@/pages/team/releaseAssist';
import ReleaseNormal from '@/pages/team/releaseNormal';
import ReleaseInfo from '@/pages/team/releaseInfo';
import Evaluate from '@/pages/project/evaluate';
import AcceptanceList from '@/pages/acceptance/list';
import AddAcceptance from '@/pages/acceptance/add';
import Acceptance from '@/pages/acceptance/info';
import RewardPunishList from '@/pages/rewardPunish/list';
import RewardPunish from '@/pages/rewardPunish/add';
import WorkLog from '@/pages/workLog/log';
import NoticeList from '@/pages/notice/list';
import BidList from '@/pages/bid/list';
import BidInfo from '@/pages/bid/info';
import BidProjectList from '@/pages/bid/projectList';
import BidTopTeamList from '@/pages/bid/topTeamList';
import BidFriendList from '@/pages/bid/friendList';
import BidTeamList from '@/pages/bid/teamList';
import BidSpecWorkerList from '@/pages/bid/specWorkerList';
import BidWorkerList from '@/pages/bid/workerList';
import Report from '@/pages/report/index';
import NoFeature from '@/pages/common/noFeature';
import NoAuth from '@/pages/common/noAuth';

const checkAuth = (to, from, resolve, reject) => {
  // test phase all route resolve
  if (to) {
    resolve();
    return;
  }
  let isAuth = true;
  const options = to.route.options;
  if (!options || options.auth === null || typeof (options.auth) === 'undefined') {
    // default value
    isAuth = true;
  } else if (options.auth === 'false') {
    isAuth = false;
  } else if (options.auth === 'true') {
    isAuth = true;
  } else {
    isAuth = Boolean(options.auth);
  }
  if (!isAuth) {
    resolve();
  } else {
    Vue.prototype.$f7.toast.create({
      text: '抱歉，您无权限。',
      position: 'center',
      closeTimeout: 1000,
    }).open();
    reject();
  }
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    options: { auth: false },
  },
  {
    path: '/home',
    redirect: '/',
  },
  {
    path: '/project/msgList/:projectId',
    name: 'msgList',
    component: MsgList,
  },
  {
    path: '/project/tree/:projectId',
    name: 'taskList',
    component: TaskList,
  },
  {
    path: '/project/split/:projectId?',
    name: 'splitProject',
    component: SplitProject,
  },
  {
    path: '/project/addAssist/:projectId?',
    name: 'addAssist',
    component: AddAssist,
  },
  {
    path: '/project/info/:projectId',
    name: 'project',
    component: Project,
  },
  {
    path: '/project/manager/:projectId',
    name: 'projectManager',
    component: ProjectManager,
  },
  {
    path: '/project/add/:projectId?',
    name: 'addProject',
    component: AddProject,
  },
  {
    path: '/project/assign/:projectId',
    name: 'assign',
    component: Assign,
  },
  {
    path: '/project/assignTeam/:projectId',
    name: 'assignTeam',
    component: AssignTeam,
  },
  {
    path: '/project/assignWorker/:projectId',
    name: 'assignWorker',
    component: AssignWorker,
  },
  {
    path: '/project/releaseAssist/:projectId',
    name: 'releaseAssist',
    component: ReleaseAssist,
  },
  {
    path: '/project/releaseNormal/:projectId',
    name: 'releaseNormal',
    component: ReleaseNormal,
  },
  {
    path: '/project/releaseInfo/:projectId',
    name: 'releaseInfo',
    component: ReleaseInfo,
  },
  {
    path: '/project/teamList/:projectId',
    name: 'teamList',
    component: TeamList,
  },
  {
    path: '/project/evaluate/:projectId',
    name: 'evaluate',
    component: Evaluate,
  },
  {
    path: '/acceptance/list/:projectId',
    name: 'acceptanceList',
    component: AcceptanceList,
  },
  {
    path: '/acceptance/add/:projectId',
    name: 'addAcceptance',
    component: AddAcceptance,
  },
  {
    path: '/acceptance/info/:applyId',
    name: 'acceptance',
    component: Acceptance,
  },
  {
    path: '/rewardPunish/list/:projectId',
    name: 'rewardPunishList',
    component: RewardPunishList,
  },
  {
    path: '/rewardPunish/add/:projectId',
    name: 'rewardPunish',
    component: RewardPunish,
  },
  {
    path: '/workLog/log/:projectId',
    name: 'workLog',
    component: WorkLog,
  },
  {
    path: '/notice/list',
    name: 'noticeList',
    component: NoticeList,
  },
  {
    path: '/bid/list',
    name: 'bidList',
    component: BidList,
  },
  {
    path: '/bid/info/:id',
    name: 'bidInfo',
    component: BidInfo,
  },
  {
    path: '/bid/projectList',
    name: 'bidProjectList',
    component: BidProjectList,
  },
  {
    path: '/bid/topTeamList',
    name: 'bidTopTeamList',
    component: BidTopTeamList,
  },
  {
    path: '/bid/teamList',
    name: 'bidTeamList',
    component: BidTeamList,
  },
  {
    path: '/bid/friendList',
    name: 'bidFriendList',
    component: BidFriendList,
  },
  {
    path: '/bid/specWorkerList',
    name: 'bidSpecWorkderList',
    component: BidSpecWorkerList,
  },
  {
    path: '/bid/workerList',
    name: 'bidWorkderList',
    component: BidWorkerList,
  },
  {
    path: '/report/index',
    name: 'Report',
    component: Report,
  },
  {
    path: '/noFeature',
    name: 'noFeature',
    component: NoFeature,
    options: { auth: false },
  },
  {
    path: '/noAuth',
    name: 'noAuth',
    component: NoAuth,
    options: { auth: false },
  },
].map((route => Object.assign(route, { beforeEnter: checkAuth })));

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js